import React from "react";
import "./Billing.scss";
import { BillingCard } from "../../../../components";

const Billing: React.FC = () => {
  return (
    <div className="Billing">
      <div className="Billing__cardContainer">
        <BillingCard />
        <BillingCard />
        <BillingCard />
      </div>
      <div className="Billing__buttonContainer">
        <button className="fillBtn__blue">Add Card</button>
        <p>Reset</p>
      </div>
    </div>
  );
};

export default Billing;
